const initialState = {
  search: {
    query: '',
    page: 1,
    pageSize: 20,
    isLoading: false,
    error: null,
    results: [],
  },
  agentsSearch: {
    query: '',
    isLoading: false,
    error: null,
    results: [],
  },
  selectedParticipants: [],
  network: {
    name: '',
    description: '',
    network_commission: '50%',
    logo: null,
    logoFile: null,
    address_type: 'publishing',
    daily_searches_enabled: true,
    has_group_chat: false,
    everyone_can_send_messages: true,
    moderators: [],
    users_allowed_ids: [],
    nameError: '',
    showNameError: false,
    commissionError: '',
    showCommissionError: false,
    descriptionError: '',
    showDescriptionError: false,
  },
  creation: {
    isLoading: false,
    error: null,
  },
  // State for networks list
  networks: {
    pendingNetworks: [],
    ownNetworks: [],
    acceptedNetworks: [],
    loadingGetNetworks: false,
    errorGetNetworks: false,
    loadingRejectInvitation: false,
    errorRejectInvitation: false,
    invitationId: null,
    loadingAcceptInvitation: false,
    errorAcceptInvitation: false,
    loadingDeleteInvitation: false,
    errorDeleteInvitation: false,
    // Plan limits and tier information from backend
    plan_type: null,
    tier: null,
    limits: {
      networks: {
        current: 0,
        max: null,
        available: null,
        can_create: false,
      },
      associations: {
        current: 0,
        max: null,
        available: null,
        can_create: false,
        max_association_companies: null,
      },
    },
    loadingSummary: false,
    errorSummary: false,
    loadingRequestUpgrade: false,
    errorRequestUpgrade: false,
    loadingGetUpgradePending: false,
    errorGetUpgradePending: false,
    upgradePending: false,
  },
  editingNetwork: null,
  fetch: {
    isLoading: false,
    error: null,
  },
  update: {
    isLoading: false,
    error: null,
  },
};

export default initialState;
